import { render, staticRenderFns } from "./MyIcon.vue?vue&type=template&id=37c1ebda&"
import script from "./MyIcon.vue?vue&type=script&lang=js&"
export * from "./MyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports